import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    keyword: '',
    userInfo: {
      "id": "",
      "username":"",
      "nickname":"",
      "mobile":"",
      "avatar":"",
      "score":0,
      "token":"",
      "user_id":0,
      "coin":0,
      "no_read_num":0,
      "ticket":0,
      "combo_num":0,
      "order_num":0
    },
    searchImage: null,
  },
  getters:{
    getKeyword:state=>{
      return state.keyword;
    },
    getSearchImage:state=>{
      return state.searchImage;
    },
    getUserInfo:state=>{
      return state.userInfo;
    },
  },
  mutations: {
    keyword(state,val) {
      state.keyword = val;
    },
    userInfo(state,userInfo) {
      state.userInfo = userInfo;
    },
    searchImage(state,searchImage) {
      state.searchImage = searchImage;
    },
  },
  actions: {},
  modules: {}
})
